import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./vuex/store";
import vuetify from "./plugins/vuetify";
import SnackbarMixin from "./mixins/SnackbarMixin";

Vue.config.productionTip = false;

Vue.mixin(SnackbarMixin);

Vue.filter("formatDate", function(value) {
  if (!value) return "";
  let current_datetime = new Date(value.toString());
  let formatted_date =
    ("0" + current_datetime.getDate()).slice(-2) +
    "/" +
    ("0" + (current_datetime.getMonth() + 1)).slice(-2) +
    "/" +
    current_datetime.getFullYear();
  return formatted_date;
});

new Vue({
  router,
  store,
  vuetify,
  created() {
    const userString = localStorage.getItem("user");
    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.commit("SET_USER_DATA", userData);
    }
  },
  render: h => h(App)
}).$mount("#app");
